import { render, staticRenderFns } from "./experiment.vue?vue&type=template&id=38b6f7f6&scoped=true&"
import script from "./experiment.vue?vue&type=script&lang=js&"
export * from "./experiment.vue?vue&type=script&lang=js&"
import style0 from "./experiment.vue?vue&type=style&index=0&id=38b6f7f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6f7f6",
  null
  
)

export default component.exports